import {action, observable, runInAction} from 'mobx';
import GenericFormStore from '../../../stores/FormStore';
import {go} from '../../../utils/navigationUtility';
import {actions, category, events} from '../../../constants/enums';
import userStore from '../../../stores/UserStore';
import {customEvent} from '../../../utils/analyticsUtil';
import request from '../../../utils/request';
import {CODE} from '../../../constants/urlConstants';

class SignupRoleStore extends GenericFormStore {
    @observable isProcessingCode = false;
    @observable isRegistering = false;
    @observable form = {
        fields: {
            email: {
                value: '',
                error: '',
                rule: 'required|email'
            },
            name: {
                value: '',
                error: '',
                rule: 'required'
            },
            familyName: {
                value: '',
                error: '',
                rule: 'required'
            },
            phone: {
                value: '',
                error: '',
                rule: 'required|phone'
            },
            password: {
                value: '',
                error: '',
                rule: 'required|password'
            },
        },
        meta: {
            isValid: true,
            error: null,
        },
    };

    @action updateUserEmail = (email) => {
        this.form.fields.email.value = email;
    };

    /**
     * Checks for abnormalities in the form before submitting to the server
     */
    _validateBeforeReq() {
        const {email, name, familyName, password} = this.form.fields;
        if (!email.value || !name.value || !password.value || email.error || name.error || familyName.error || password.error) {
            this.form.meta.error = 'Please fill all the fields correctly';
            this._clearMetaError();
            return false;
        }

        return true;
    }

    _clearMetaError = () => {
        setTimeout(() => {
            runInAction(() => {
                this.form.meta.error = '';
            });
        }, 3500);
    };

    /**
     *
     * @param {*} role a string representing a teacher or a student. 'role' is not a form input field
     */
    @action
    async register(role, context, hasRedirect) {
        if (!this._validateBeforeReq()) {
            return;
        }

        const {fields} = this.form;
        const signUpFormFields = {};
        Object.keys(fields).forEach((field) => {
            signUpFormFields[field] = fields[field].value;
        });

        try {
            const {email, password} = signUpFormFields;
            this.isRegistering = true;
            customEvent(events.CustomEvent, {category: category.SignUp, action: actions.Click, label: 'Internal'});
            if (signUpFormFields.phone) {
                signUpFormFields.phone = signUpFormFields.phone.replace(/\s/g,'');
            }
            await userStore.logout(false, false);
            await userStore.register({...signUpFormFields, role});
            await userStore.login(email, password, role, context, hasRedirect);
            // await userStore.postSignup(role, context);
        } catch (err) {
            runInAction(() => {
                switch (err.code) {
                    case 'InvalidParameterException':
                        this.form.meta.error = 'Please fill all the fields';
                        break;
                    case 'UserLambdaValidationException':
                        try {
                            const errorDetails = JSON.parse('{' + err.message.split('{')[1].slice(0,-1));
                            if (errorDetails.provider === 'Cognito') {
                                this.form.meta.error = 'A profile already exists with this email. Please go to the login page.';
                            } else {
                                this.form.meta.error = `This email was already used to register using ${errorDetails.provider}, please login with your ${errorDetails.provider} account`;
                            }
                        } catch (err) {
                            this.form.meta.error = err.message;
                        }
                        break;
                    default:
                        this.form.meta.error = err.message;
                }
            });
        } finally {
            runInAction(() => {
                this.isRegistering = false;
            });
        }
    }

    @action onClickDone = () => {
        go('/siginin');
    };

    @action getRegistrationCodeUserDetails = async (code) => {
        this.isProcessingCode = true;
        try {
            const codeCreds = await request(`${CODE}/${code}`);
            return codeCreds;
        } catch (err) {
            return {err: err};
        } finally {
            runInAction(() => {
                this.isProcessingCode = false;
            });
        }
    }
}

const signupRoleStore = new SignupRoleStore();
export default signupRoleStore;
